(function () {
  var WORDS = [
    'E<em>\u039B</em>SY',
    'F<em>\u039B</em>ST',
    'CLE<em>\u039B</em>N',
    'T<em>\u039B</em>STY'
  ];
  var INTERVAL_MS = 3000;
  var FADE_MS = 350;

  function run() {
    var strong = document.querySelector('main[data-template="index"] .hero h1 strong:last-of-type');
    if (!strong) return;

    var inner = document.createElement('span');
    inner.className = 'hero-rotating-word-inner';
    inner.innerHTML = WORDS[0];
    strong.innerHTML = '';
    strong.className = 'hero-rotating-word-wrap';
    strong.appendChild(inner);

    var index = 0;
    setInterval(function () {
      inner.style.opacity = '0';
      setTimeout(function () {
        index = (index + 1) % WORDS.length;
        inner.innerHTML = WORDS[index];
        inner.style.opacity = '1';
      }, FADE_MS);
    }, INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
